import { canViewPackageImportsList } from '../../offline/package-exports-permissions'
import { getNotificationTarget } from './notification-target.util'
import { NOTIFICATION_TARGETS, NOTIFICATION_VIEW_AVAILABILITY } from './notification-center.const'

/** User types allowed into the Admin page (Admin, OrganizationAdmin, MultiOrganizationAdmin). */
const ADMIN_PAGE_USER_TYPES = new Set([1, 2, 3])

const isAdminPageUser = userType => ADMIN_PAGE_USER_TYPES.has(userType)

const TARGET_PERMISSIONS = {
  [NOTIFICATION_TARGETS.CRASH]: () => true,
  [NOTIFICATION_TARGETS.USERS]: isAdminPageUser,
  [NOTIFICATION_TARGETS.CSV_IMPORTS]: isAdminPageUser,
  [NOTIFICATION_TARGETS.ZIP_IMPORTS]: canViewPackageImportsList,
}

/** The Admin page redirects mobile users to the map. */
const DESKTOP_ONLY_TARGETS = new Set([NOTIFICATION_TARGETS.USERS, NOTIFICATION_TARGETS.CSV_IMPORTS])

/**
 * Whether "View" can open the notification target for this user on this device.
 * @param {object} notification
 * @param {{ userType?: number|string, isMobile?: boolean }} context
 */
export function getNotificationViewAvailability(notification, { userType, isMobile }) {
  const target = getNotificationTarget(notification)
  const isPermitted = TARGET_PERMISSIONS[target]?.(Number(userType)) ?? false
  if (!isPermitted) return NOTIFICATION_VIEW_AVAILABILITY.NONE
  if (isMobile && DESKTOP_ONLY_TARGETS.has(target)) return NOTIFICATION_VIEW_AVAILABILITY.DESKTOP_ONLY
  return NOTIFICATION_VIEW_AVAILABILITY.ENABLED
}
